import React from 'react';
import clsx from 'clsx';

import Icon from './Icon';

import styles from './StreetViewController.module.scss';
import FloatingToggleButton from './FloatingToggleButton';
import Info from './Info';
import { hasBrandLabel } from '../api/brandUtil';

export default function StreetViewController({ result, onCloseStreetView }) {
	const isBrandLabel = hasBrandLabel(result);

	return (
		<div className={styles.root}>
			<div
				className={clsx(
					styles.infoContainer,
					isBrandLabel ? styles.infoContainerColumn : null
				)}
			>
				<div>{result.brand}</div>
				<Info
					name={result.name}
					address={result.address}
					variant={isBrandLabel ? 'block' : null}
				/>
			</div>
			<FloatingToggleButton
				show={true}
				enabled={true}
				icon={<Icon icon="icon/close_blue.png" size="small" />}
				className={styles.button}
				onClick={onCloseStreetView}
			/>
		</div>
	);
}
